import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Seo from "../components/Seo";
import { api } from "../lib/api";
import { t } from "../lib/i18n";

export default function OrderPayment() {
  const { orderNo, lang = "en" } = useParams();
  const zh = lang === "zh";
  const [txid, setTxid] = useState("");
  const [note, setNote] = useState("");
  const [done, setDone] = useState(false);
  async function submit() {
    await api(`/api/orders/${orderNo}/payment-submit`, { method: "POST", body: JSON.stringify({ txid, note }) });
    setDone(true);
  }
  return (
    <>
      <Seo title={t(lang, "paymentInstructions")} description={`Submit TXID and payment remark for order ${orderNo || ""} at SellerSupply Shop.`} />
      <section className="container-page py-8">
        <div className="panel mx-auto max-w-2xl p-6">
          <h1 className="text-2xl font-black">{t(lang, "paymentInstructions")}</h1>
          <p className="mt-2 text-slate-600">{zh ? `订单 ${orderNo}。付款后提交 TXID 或付款备注，后台会人工审核。` : `Order ${orderNo}. Send payment, then submit the TXID or a short remark for review.`}</p>
          <div className="mt-5 rounded-[24px] bg-[#FDF9F1] p-4">
            <p className="font-bold">USDT TRC20</p>
            <p className="break-all text-sm">TXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</p>
            <button className="btn-secondary mt-3" onClick={() => navigator.clipboard?.writeText("TXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX")}>{zh ? "复制地址" : "Copy Address"}</button>
          </div>
          <div className="mt-5"><input className="input mt-3" placeholder="TXID / transaction reference" value={txid} onChange={(e) => setTxid(e.target.value)} /><textarea className="input mt-3 rounded-[24px]" placeholder={zh ? "付款备注" : "Payment remark"} value={note} onChange={(e) => setNote(e.target.value)} /></div>
          {done ? <Link className="btn-primary mt-5" to={`/${lang}/payment-submitted`}>{zh ? "已提交，查看结果" : "Submitted, continue"}</Link> : <button className="btn-primary mt-5" onClick={submit}>{t(lang, "submitPaymentInfo")}</button>}
        </div>
      </section>
    </>
  );
}
